var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('transition',{attrs:{"name":"flow-object-active-node-trans","mode":"out-in"}},[(_vm.localActive)?_c('div',{},[_vm._t("default",function(){return [_vm._v(" Custom Tab: "+_vm._s(_vm.name)+" ")]})],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }